import actions from 'src/modules/event/publicschedule/eventPublicScheduleActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.PUBLIC_SCHEDULE_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.PUBLIC_SCHEDULE_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PUBLIC_SCHEDULE_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PUBLIC_SCHEDULE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.PUBLIC_SCHEDULE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PUBLIC_SCHEDULE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};

